import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { Permission } from './types';

const ADMIN_ONLY_PERMISSIONS_BY_ENTITY: Partial<
  Record<Entities, Permission[]>
> = {
  [Entities.tenant]: ['canEdit'],
  [Entities.fileServiceProviderConfig]: ['canAdd', 'canEdit', 'canDelete'],
  [Entities.webShopDefinition]: ['canDelete'],
};

type Props = {
  entity: Entities;
  permission: Permission;
};

export const isAdminOnlyPermission = ({
  entity,
  permission,
}: Props): boolean => {
  return (ADMIN_ONLY_PERMISSIONS_BY_ENTITY[entity] ?? []).includes(permission);
};
